import { Box } from '@material-ui/core';
import { formatMoney } from '@nemuru-eng/js-api-client';

import { amountToValueMoneyMapper } from '../../../../../../../../utils/mappers/amountToValueMoneyMapper';
import { Text } from '../../../../../../../shared/components/Text';
import { TransactionsListRowProps } from '../../../types/TransactionsListRowProps';

export const vatAmountFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.3,
    field: 'vat_amount',
    align: 'right',
    headerName: (
      <Box textAlign={'right'}>
        <Text tId={'VAT_AMOUNT'} />
      </Box>
    ),
    renderCell: (rowData: TransactionsListRowProps) => (
      <>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            whiteSpace: 'break-spaces',
            lineHeight: '1.43',
          }}
        >
          <div className={'line-clamp-3'}>{formatMoney(amountToValueMoneyMapper(rowData.row.vatAmount))}</div>
        </div>
      </>
    ),
  };
};
